export default {
  step6:[
    {
      id:32,
      step: 6,
      stepJp: "ミルグレイン",
      name: "両サイド",
      property: "milgrain",
      val: "_milbothsides",
      summary:"",
      price:17000,
    },
    {
      id:33,
      step: 6,
      stepJp: "ミルグレイン",
      name: "中央ライン",
      property: "milgrain",
      val: "_milcenter",
      summary: "",
      price:12000,
    },
    {
      id:34,
      step: 6,
      stepJp: "ミルグレイン",
      name: "ミルグレイン不要",
      property: "milgrain",
      val: "",
      summary: "",
      price:0,
    },
  ]
}
